import React from "react";
import { connect } from "react-redux";
const mapStateToProps = state => {
  return { experience: state.experience };
};
function TimeLine(props) {
  return props.experience.map((exp, k) => (
    <div className="timeline" key={k}>
      <div className="icon" />
      <div className="date-content">
        <div className="date-outer">
          <span className="date">
            <span className="month">{exp.month}</span>
            <span className="year">{exp.year}</span>
          </span>
        </div>
      </div>
      <div className="timeline-content">
        <h5 className="title">{exp.title}</h5>
        <h6 className="font-size11 font-weight-600">at {exp.company}, {exp.location}</h6>
        <div className="description">
          {exp.description.map((desc, index) => (
            <React.Fragment key={index}>
              <h6 className="font-size14 mb-2">
                {"> "}
                {desc.project}
              </h6>
              <p className="mb-2">{desc.projectBrief}</p>
              <div>
                <h6 className="font-size12 mb-1 font-weight-500">
                  Responsibilities
                </h6>
                <div>
                  <ul>
                    {desc.responsibility.map((resp, j) => (
                      <li key={j}>{resp}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <p>
                <span>Stack : </span>
                {desc.techStack}
              </p>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  ));
}

export default connect(mapStateToProps)(TimeLine);
